/*
 * Entry point of the application.
 * Only platform bootstrapping code should be here.
 * For app-specific initialization, use `app/app.component.ts`.
 */

import {
  enableProdMode,
  LOCALE_ID,
  APP_INITIALIZER,
  importProvidersFrom,
  provideZoneChangeDetection,
} from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from '@env/environment';
import { AppComponent } from './app/app.component';
import { OverlayModule } from '@angular/cdk/overlay';
import { ServiceWorkerModule } from '@angular/service-worker';
import { AppRoutingModule } from './app/app-routing.module';
import { CoreModule } from '@core';
import { ReactiveFormsModule } from '@angular/forms';
import { withInterceptorsFromDi, provideHttpClient } from '@angular/common/http';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { DatePipe } from '@angular/common';
import { LocaleIdService } from '@app/@i18n/locale-id.service';
import { BrowserAnimationsModule, provideAnimations } from '@angular/platform-browser/animations';
import { provideNativeDateAdapter } from '@angular/material/core';

if (environment.production) {
  enableProdMode();
}

const bootstrap = () =>
  bootstrapApplication(AppComponent, {
    providers: [
      provideZoneChangeDetection(),
      importProvidersFrom(
        BrowserModule,
        BrowserAnimationsModule,
        ReactiveFormsModule,
        TranslateModule.forRoot(),
        CoreModule,
        AppRoutingModule,
        ServiceWorkerModule.register('/ngsw-worker.js', {
          enabled: environment.production,
        }),
        OverlayModule,
      ),
      { provide: LOCALE_ID, useClass: LocaleIdService },
      DatePipe,
      {
        provide: APP_INITIALIZER,
        useFactory: appInitializerFactory,
        deps: [TranslateService],
        multi: true,
      },
      provideAnimations(),
      provideNativeDateAdapter(),
      provideHttpClient(withInterceptorsFromDi()),
    ],
  });

function appInitializerFactory(translate: TranslateService) {
  return () => {
    return firstValueFrom(translate.use('fr'));
  };
}

bootstrap().catch();
